export function output(n:number):number[][]{
    if(n === 0){
        return [
            [
                90, 90, 90, 180,
                180, 90, 180, 180,
                180, 180, 180, 180,
                180, 180, 180, 180,
                180, 90, 0, 180,
                90, 90, 90, 0
            ],
            [
                0, 90, 90, 90,
                180, 0, 90, 180,
                180, 180, 180, 180,
                180, 180, 180, 180,
                180, 180, 90, 180,
                180, 90, 90, 90
            ]
        ]
    }
    else if(n === 1){
        return [
            [
                90, 90, 180, 45,
                90, 180, 180, 45,
                45, 180, 180, 45,
                45, 180, 180, 45, 
                90, 0, 90, 180,
                90, 90, 90, 0
            ],
            [
                0, 90, 90, 45, 
                180, 90, 180, 45, 
                45, 180, 180, 45, 
                45, 180, 180, 45, 
                0, 90, 180, 90, 
                180, 90, 90, 90
            ]
        ]
    }
    else if(n === 2){
        return [
            [
                90, 90, 90, 180, 
                90, 90, 180, 180, 
                90, 90, 0, 180, 
                180, 90, 90, 0, 
                180, 90, 90, 180, 
                90, 90, 90, 0
            ],
            [
                0, 90, 90, 90, 
                180, 90, 90, 180, 
                0, 90, 90, 180, 
                180, 0, 90, 90, 
                180, 180, 90, 90, 
                180, 90, 90, 90
            ]
        ]
    }
    else if(n === 3){
        return [
            [
                90, 90, 90, 180, 
                90, 90, 180, 180, 
                90, 90, 0, 180, 
                90, 90, 180, 0, 
                90, 90, 0, 180, 
                90, 90, 90, 0
            ],
            [
                0, 90, 90, 90, 
                180, 90, 90, 180, 
                0, 90, 90, 180, 
                180, 90, 90, 0, 
                0, 90, 90, 180, 
                180, 90, 90, 90
            ]
        ]
    }
    else if(n === 4){
        return [
            [
                90, 180, 90, 180, 
                180, 180, 180, 180, 
                180, 90, 0, 180, 
                90, 90, 180, 0, 
                45, 45, 180, 180, 
                45, 45, 90, 0
            ],
            [
                0, 90, 0, 90, 
                180, 180, 180, 180, 
                180, 180, 90, 180, 
                180, 90, 90, 0, 
                45, 45, 180, 180, 
                45, 45, 180, 90
            ]
        ]
    }
    else if(n === 5){
        return [
            [
                90, 90, 90, 180, 
                180, 90, 90, 0, 
                180, 90, 90, 180, 
                90, 90, 180, 0, 
                90, 90, 0, 180, 
                90, 90, 90, 0
            ],
            [
                0, 90, 90, 90, 
                180, 0, 90, 90, 
                180, 180, 90, 90, 
                180, 90, 90, 0, 
                0, 90, 90, 180, 
                180, 90, 90, 90
            ]
        ]
    }
    else if(n === 6){
        return [
            [
                90, 90, 90, 180, 
                180, 90, 90, 0, 
                180, 90, 90, 180, 
                180, 90, 180, 0, 
                180, 90, 0, 180, 
                90, 90, 90, 0
            ],
            [
                0, 90, 90, 90, 
                180, 0, 90, 90, 
                180, 180, 90, 90, 
                180, 0, 90, 0, 
                180, 180, 90, 180, 
                180, 90, 90, 90
            ]
        ]
    }
    else if(n === 7){
        return [
            [
                90, 90, 90, 180,
                90, 90, 180, 180,
                45, 45, 180, 180,
                45, 45, 180, 180,
                45, 45, 180, 180,
                45, 45, 90, 0
            ],
            [
                0, 90, 90, 90,
                180, 90, 90, 180,
                45, 45, 180, 180,
                45, 45, 180, 180,
                45, 45, 180, 180,
                45, 45, 180, 90
            ]
        ]
    }
    else if(n === 8){
        return [
            [
                90, 90, 90, 180,
                180, 90, 180, 180,
                180, 90, 0, 180,
                180, 90, 180, 180,
                180, 90, 0, 180,
                90, 90, 90, 0
            ],
            [
                0, 90, 90, 90,
                180, 0, 90, 180,
                180, 180, 90, 180,
                180, 0, 90, 180,
                180, 180, 90, 180,
                180, 90, 90, 90
            ]
        ]
    }
    else if(n === 9){
        return [
            [
                90, 90, 90, 180,
                180, 90, 180, 180,
                180, 90, 0, 180,
                90, 90, 180, 180,
                90, 90, 0, 180,
                90, 90, 90, 0
            ],
            [
                0, 90, 90, 90,
                180, 0, 90, 180,
                180, 180, 90, 180,
                180, 90, 90, 180,
                0, 90, 90, 180,
                180, 90, 90, 90
            ]
        ]
    }
    else
        return output(0)
}
